import * as idEndpoints from './id';

export const venues = {
  id: {
    ...idEndpoints,
  },
};
